import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../components/layout/Navbar";
import { useAuth } from "../../contexts/AuthContext";
import "../../styles/home.css";

const modules = [
  ["👥", "Employés", "Profils, contrats, postes et informations RH centralisées."],
  ["🌴", "Congés", "Demandes, validation en cascade et solde mis à jour automatiquement."],
  ["📅", "Absences", "Calendrier RH partagé et planning d'équipe interactif."],
  ["📄", "Recrutement", "Gestion des offres, cvthèque, candidatures et scoring IA de matching."],
  ["🤖", "Assistant IA", "Réponses intelligentes basées sur les documents internes et les CV."],
  ["📊", "Dashboard", "Statistiques RH en temps réel et indicateurs clés de performance."],
];

function HomePage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleCTA = () => {
    if (user) {
      navigate(`/${user.role}/dashboard`);
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="home-page-container">
      {/* Global Navbar */}
      <Navbar />

      <section className="hero" id="home">
        <div className="hero-left">
          <div className="tag">Plateforme RH intelligente</div>

          <h1>
            Gérez vos ressources humaines avec une interface moderne,
            rapide et intelligente.
          </h1>

          <p>
            Smart-HR centralise la gestion des collaborateurs, congés, absences et recrutements dans une seule plateforme dynamique conçue pour les équipes modernes.
          </p>

          <div className="hero-buttons">
            <button onClick={handleCTA} className="main-btn">
              {user ? "Accéder à mon espace" : "Essayer l'espace Démo"}
            </button>
            <a href="#modules" className="outline-btn">
              Découvrir les modules
            </a>
          </div>

          <div className="stats">
            <div>
              <strong>+40%</strong>
              <span>Efficacité RH</span>
            </div>
            <div>
              <strong>24h/7</strong>
              <span>Scoring CV IA</span>
            </div>
            <div>
              <strong>3 Rôles</strong>
              <span>Employé, Manager, RH</span>
            </div>
          </div>
        </div>

        <div className="hero-right">
          <div className="dashboard-card">
            <div className="card-top">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <div className="dashboard-title">
              <div>
                <h3>Plateforme Smart-HR</h3>
                <p>Vue d'ensemble de l'activité</p>
              </div>
              <div className="status">Live Demo</div>
            </div>

            <div className="chart">
              <div style={{ height: "45%" }}></div>
              <div style={{ height: "70%" }}></div>
              <div style={{ height: "55%" }}></div>
              <div style={{ height: "85%" }}></div>
              <div style={{ height: "65%" }}></div>
            </div>

            <div className="mini-grid">
              <div className="mini approved">
                <span>Congés approuvés</span>
                <strong>18</strong>
              </div>
              <div className="mini pending">
                <span>Demandes en attente</span>
                <strong>7</strong>
              </div>
            </div>

            <div className="assistant-box">
              <span>Smart-HR Matcher IA</span>
              <p>“Candidat Damien Vart : 92% de matching avec l'offre React Senior.”</p>
            </div>
          </div>
        </div>
      </section>

      <section className="modules" id="modules">
        <div className="section-header">
          <span className="tag">Modules intégrés</span>
          <h2>Une solution complète pour piloter vos RH</h2>
        </div>

        <div className="module-grid">
          {modules.map((m) => (
            <div className="module-card" key={m[1]}>
              <div className="module-icon">{m[0]}</div>
              <h3>{m[1]}</h3>
              <p>{m[2]}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="workflow" id="workflow">
        <div className="workflow-content">
          <span className="tag">Workflow fluide</span>
          <h2>Validation des congés simplifiée</h2>
          <p>
            Un processus clair et automatisé : l'employé soumet sa demande, le manager effectue une première validation d'équipe, et le responsable RH signe l'approbation finale qui débite le solde.
          </p>
        </div>

        <div className="steps">
          <div className="step-card">
            <span className="step-num">1</span>
            <h4>Employé</h4>
            <p>Soumet sa demande de congé</p>
          </div>
          <span className="step-arrow">➔</span>
          <div className="step-card">
            <span className="step-num">2</span>
            <h4>Manager</h4>
            <p>Vérifie et valide pour l'équipe</p>
          </div>
          <span className="step-arrow">➔</span>
          <div className="step-card">
            <span className="step-num">3</span>
            <h4>RH / Admin</h4>
            <p>Approbation finale & débit solde</p>
          </div>
        </div>
      </section>

      <section className="ai" id="ai">
        <div className="ai-card">
          <span className="tag">Intelligence Artificielle</span>
          <h2>Matching intelligent CV & scoring de recrutement</h2>
          <p>
            Accélérez vos recrutements grâce à notre algorithme intelligent. Comparez instantanément les compétences clés extraites des CV reçus avec les fiches de poste pour obtenir un classement par score de pertinence.
          </p>
          <div className="ai-demo-badge">Recommandé par 98% des recruteurs</div>
        </div>
      </section>

      <footer className="footer-home">
        <p>&copy; 2026 Smart-HR. Conçu pour simplifier la vie des équipes.</p>
      </footer>
    </div>
  );
}

export default HomePage;